import React from 'react';

// MUI
import { useTheme } from '@mui/material';
import CardHeader, { CardHeaderProps } from '@mui/material/CardHeader';

const MapCardHeader = (props: CardHeaderProps) => {
  const theme = useTheme();
  return (
    <CardHeader
      
      {...props}
      style={{
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(1),
      }}
      sx={{
        '.MuiCardHeader-root': {
          padding: theme.spacing(1),
        },
        '.MuiCardHeader-title': {
          color: 'common.white',
        },
        '.MuiCardHeader-subheader': {
          color: '#eeeeee',
        },
        // lets long titles shrink instead of pushing the close button out of the card
        '.MuiCardHeader-content': {
          minWidth: 0,
        },
        '.MuiCardHeader-action': {
          color: 'common.white',
          display: 'flex',
          alignSelf: 'auto',
          flexShrink: 0,
        },
      }}
    />
  );
};

export default MapCardHeader;
